module.exports = __webpack_public_path__ + "static/img/Max_Gawn_desktop.9eecea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Max_Gawn_desktop.jpg
// module id = /TP3
// module chunks = 0